var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { withTheme } from 'styled-components';
import { useInView } from 'react-intersection-observer';
import Box from '../box/Box';
import { lazyOptions } from './shared';
export var BgImage = withTheme(function (_a) {
    var theme = _a.theme, src = _a.src, _b = _a.lazy, lazy = _b === void 0 ? true : _b, rest = __rest(_a, ["theme", "src", "lazy"]);
    var _c = useInView(lazyOptions), ref = _c[0], inView = _c[1];
    var srcUrls = undefined;
    if (inView) {
        srcUrls = Array.isArray(src) ? src.map(function (url) { return "url(\"".concat(url, "\")"); }) : "url(\"".concat(src, "\")");
    }
    return React.createElement(Box, __assign({ ref: ref }, rest, { backgroundImage: srcUrls }));
});
BgImage.defaultProps = {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
};
export default BgImage;
//# sourceMappingURL=BgImage.js.map